<template>
  <div class="upload-doc-modal-creare-contract-wrapper">
    <span v-if="szvmDocuments.length > 0">
      <el-button
        type="primary"
        style="margin-bottom: 16px; margin-right: 12px"
        @click="showModal"
      >
        Перейти к загрузке файлов сзвм
      </el-button>
    </span>
    <span v-else>
      <el-date-picker
        v-model="documentCreateDate"
        style="margin-right: 8px"
        type="month"
        placeholder="Месяц и год сзвм"
      />
      <el-button
        style="margin-bottom: 16px; margin-right: 12px"
        :disabled="!documentCreateDate"
        :loading="loading"
        type="success"
        @click="createdDocument({ document_create_date: documentCreateDate })"
      >
        Создать документ
      </el-button>
    </span>

    <el-dialog
      v-if="isShowModal"
      :loding="loading"
      :before-close="checkForm"
      title="Документы СЗВМ"
      :visible.sync="isShowModal"
      :width="widthDialog"
      :append-to-body="true"
      :close-on-click-modal="false"
      class="upload-doc-modal"
      @opened="onDialogOpened"
    >
      <el-collapse>
        <el-collapse-item title="Создать новый документ">
          <span>
            <el-date-picker
              v-model="documentCreateDate"
              style="margin-right: 8px"
              type="month"
              placeholder="Месяц и год сзвм"
            />
            <el-button
              style="margin-bottom: 16px; margin-right: 12px; width: 235px"
              :disabled="!documentCreateDate"
              :loading="loading"
              type="success"
              @click="
                createdDocument({ document_create_date: documentCreateDate })
              "
            >
              Создать документ
            </el-button>
          </span>
        </el-collapse-item>
      </el-collapse>
      <szvm-documents-list
        v-if="szvmDocuments.length > 0"
        :pasted-file="pastedFile"
        :loading="loading"
        :documents="szvmDocuments"
        :contract-id="szvmDocuments[0].id"
        :approvement-contract-id="approvedContract ? approvedContract.id : null"
        @startUpload="onStartUpload"
        @deleteDocument="deleteDocument"
        @signDocument="signDocument"
        @setActiveDocument="setActiveDocument"
        @deleteFile="deleteFile"
        @uploadedImages="uploadedImagesFile"
        @getZip="getZip"
        @uploaded="uploaded"
        @saveNumber="saveNumber"
        @onAborted="onAborted"
      />
    </el-dialog>
  </div>
</template>

<script>
import { documents_workflow } from '@/helpers/typeContract'
import szvmDocumentsList from './components/SzvmDocumentsList'

export default {
  name: 'UploadDocAndCreateSzvmModal',
  components: {
    szvmDocumentsList,
  },
  props: {
    szvmDocuments: {
      type: Array,
      default: () => [],
    },
    contragentContracts: {
      type: Object,
      default: () => {},
    },
    short_name: {
      type: String,
    },
    inn: {
      type: String,
    },

    loading: {
      type: Boolean,
      default: false,
    },
    nameDocument: {
      type: String,
      default: '',
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      documentCreateDate: '',

      options: documents_workflow,
      documents_workflow:
        this.contragentContracts?.documents_workflow || 'undefined',
      form: {},
      advancedFormModel: {},
      document: '',
      fileExpire: '',
      formNameDocument: '',
      pastedFile: null,
      isApprove: 0,
      isShowModal: false,
      isFileList: false,
      approvedContract: null,
    }
  },
  computed: {
    documentId() {
      return this.szvmDocuments.length > 0 ? this.szvmDocuments[0].id : 0
    },
    issetDocument() {
      return Boolean(this.szvmDocuments.length > 0)
    },
    fileList() {
      return this.szvmDocuments ? this.document?.files : []
    },
    countFiles() {
      let count = 0

      if (this.document.files) {
        count = this.document.files.length
      }

      return count
    },
    noFiles() {
      // могут добавлять файлы ?
      return !this.canUpload && (!this.document || this.countFiles === 0)
    },
    uploadFiles() {
      return this.canUpload && !this.approvedContract
    },
  },
  watch: {
    contragentContracts: {
      immediate: true,
      handler(value) {
        this.documents_workflow = value?.documents_workflow || 'undefined'
      },
    },
  },
  methods: {
    updatedTypeContarct() {
      this.$emit('updatedTypeContarct', {
        documents_workflow: this.documents_workflow,
        id: this.contragentContracts?.id,
      })
    },
    getZip(id) {
      this.$emit('getedZip', id)
    },
    deleteFile(data) {
      this.$emit('deleteFileDocument', data)
    },
    saveNumber(data) {
      this.$emit('savedNumber', {
        ...data,
        contract_id: this.contragentContracts.id,
      })
    },
    uploadedImagesFile(param1, param2) {
      this.$emit('uploadImages', param1, param2)
    },
    deleteDocument(data) {
      this.$emit('deletedDocument', data)
    },
    signDocument(data) {
      this.$emit('signedDocument', data)
    },
    setActiveDocument(data) {
      this.$emit('setedActiveDocument', data)
    },
    canUpload() {
      return this.$canAction('uploadFilesAuto', this.userInfo)
    },

    getApproveOneDoc(documents) {
      // если есть аппрув док то берем только его, если нет то берем первый попавшийся ибо все равно не будет правильного
      let documentItem

      for (let key in documents) {
        if (documentItem === undefined) {
          documentItem = documents[key]
        }
        if (documents[key].approve_status.length !== 0) {
          documentItem = documents[key]
        }
      }
      this.document = documentItem
      this.$emit('ready', this.document)
    },
    createdDocument(data) {
      if (this.$canAction('createDocAuto', this.userInfo)) {
        this.$emit('createdDocument', data)
      }
    },
    checkForm(done) {
      window.removeEventListener('paste', this.handlePaste)
      done()
    },
    showModal() {
      this.isShowModal = true
    },
    uploaded(file) {
      this.fileList.unshift(file)
      this.pastedFile = null
      window.addEventListener('paste', this.handlePaste)
    },
    onDialogOpened() {
      window.addEventListener('paste', this.handlePaste)
    },
    handlePaste(ev) {
      const items = (ev.clipboardData || ev.originalEvent.clipboardData).items

      for (let i in items) {
        let item = items[i]

        if (item.kind === 'file') {
          let blob = item.getAsFile()
          let allowedFormats = ['image/jpeg', 'image/png']
          let isSize = blob.size / 1024 / 1024 < 15

          if (!allowedFormats.includes(blob.type)) {
            this.$alert(
              'Ошибка при загрузке файла ' + blob.name + '. Неверный формат',
            )
          }
          if (!isSize) {
            this.$alert(
              'Ошибка при загрузке файла ' + blob.name + '. Превышен размер',
            )
          }
          if (isSize && allowedFormats.includes(blob.type)) {
            this.pastedFile = blob
            console.log(' this.pastedFile', this.pastedFile)
          }
        }
      }
    },
    onStartUpload() {
      window.removeEventListener('paste', this.handlePaste)
    },
    onAborted() {
      window.addEventListener('paste', this.handlePaste)
    },
  },
}
</script>

<style lang="sass">
.upload-doc-modal-creare-contract-wrapper
  display: flex
  align-items: center
  margin-bottom: 10px
.upload-doc-modal
  font-family: "Rubik", sans-serif
  .el-collapse-item__header
    font-weight: bold
    font-size: 1.1em
    color: #67C23A
  .box-card
    z-index: 5000 !important
    position: fixed
    left: 0
    top: 0
    width: 20%
    background-color: white
  .help_upload
    padding-left: 10px !important
    color: #a5a5a5
    font-size: 15px
    font-family: "Rubik", sans-serif
  .help_upload li
    padding-top: 5px
  .el-alert--success
    font-weight: bold !important
    cursor: pointer !important
.wrapper-choise-type
  display: flex
  width: 420px
  margin-bottom: 16px
  &_select
    width: 90%
    display: block
    margin-right: 8px
</style>
